import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'el-base-neo-search-filed',
  templateUrl: './search-filed.component.html',
  styleUrls: ['./search-filed.component.scss'],
})
export class SearchFiledComponent {
  @Input() formGroup!: any;
  @Input() inputControlName = 'nic_passport';
  @Input() dropdownList: {
    value: string;
    name?: string;
  }[] = [];
  @Input() isClearData = false;
  @Input() isFormDisabled = false;
  @Input() isEditDisabled = false;
  @Input() readOnly = false;
  @Input() label = 'leads.add-lead.fields.nic-passport';
  @Input() placeholder = 'leads.add-lead.fields.nic-passport-placeholder';
  @Input() errorMessage = 'leads.error-messages.nic-passport';
  @Output() searchSelected = new EventEmitter<any>();
  @Output() clearedSearch = new EventEmitter<void>();
  @Output() findSearchList = new EventEmitter<void>();
}
